import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const DependentSchema = withDefaults({
  type: 'dependent',
  objectExtensions: ['dependent'],
  fields: [
    {
      kind: 'attribute',
      name: 'birthDate',
    },
    {
      kind: 'attribute',
      name: 'email',
    },
    {
      kind: 'attribute',
      name: 'firstName',
    },
    {
      kind: 'attribute',
      name: 'lastName',
    },
    {
      kind: 'attribute',
      name: 'relationship',
    },
    {
      kind: 'attribute',
      name: 'flavor',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'deletedAt',
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasProgramInstances',
      type: 'tas-program-instance',
      options: {
        async: false,
        inverse: 'dependent',
      },
    },
  ],
});

export default DependentSchema;
